// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__31L3e","buttons":"RemoveExpirationActionButtons_buttons__3hfKa"};